import { Navigate } from 'react-router-dom';
import GoogleChatPanel from '../components/chat/GoogleChatPanel';

export default function ChatPopupPage() {
  const token = localStorage.getItem('mfg_token');
  if (!token) return <Navigate to="/login" replace />;

  return (
    <div className="flex h-screen bg-gray-950 text-gray-100">
      <GoogleChatPanel />
    </div>
  );
}
